/**
 * 后端 API 根地址。
 * 生产可配置为空字符串表示同源（Nginx 反代）；开发默认 http://localhost:3000。
 * 注意：不能用 || 回退，否则 '' 会被当成 falsy 落到 localhost:3000。
 */
const DEV_DEFAULT = 'http://localhost:3000';

export function getApiBaseUrl () {
    const base = process.env.VUE_APP_API_BASE_URL;
    if (base !== undefined && base !== null) {
        if (base === '') {
            if (typeof window !== 'undefined' && window.location && window.location.origin) {
                return window.location.origin;
            }
            return '';
        }
        return base;
    }
    return DEV_DEFAULT;
}
